import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetPointSystemItems } from "src/app/store/point-system/point-system.action";

export function PointSystemResolver() {
    return inject(Store).dispatch(new GetPointSystemItems());
}